/* Mixed-version deploys: the "episodes become campaigns" fields and queries
 * land on the backend separately from this UI. A request that names one of
 * them fails validation on an older server; callers catch that, stay quiet
 * (`SILENT_CONTEXT`) and fall back to what the old schema offers. */

const GAP_PATTERNS = [
  /unknown field/i,
  /cannot query field/i,
  /unknown argument/i,
  /unknown type/i,
  // Input coercion on an older schema: `Field "format" is not defined by type
  // PropertyCampaignLinkInput`.
  /field "[^"]+" is not defined by type/i,
  /is not defined by type/i,
];

/** True when the error is the server not knowing a field / type we asked for
 *  (an older schema), as opposed to a real failure. */
export const isSchemaGapError = (error: unknown): boolean => {
  const e = error as {
    message?: string;
    graphQLErrors?: Array<{ message?: string }>;
  } | null;
  const messages = [
    e?.message ?? String(error ?? ''),
    ...(e?.graphQLErrors ?? []).map((g) => g.message ?? ''),
  ];
  return messages.some((m) => GAP_PATTERNS.some((re) => re.test(m)));
};

/** Apollo context for requests whose failure the caller handles itself. */
export const SILENT_CONTEXT = { suppressGlobalErrorToast: true } as const;
